import { Theme, useMediaQuery as useMuiMediaQuery } from "@mui/material";
import { UseMediaQueryOptions } from "@mui/system/useMediaQuery/useMediaQuery";

const useMediaQuery = (queryInput: string | ((theme: Theme) => string), options?: UseMediaQueryOptions) => {
    return useMuiMediaQuery(queryInput, options);
}

export default useMediaQuery;